<template>
  <div
    class="quick-menu-list"
    v-if="expenseCreateItem"
    :class="{ maintenance: showMaintenanceFlag(expenseCreateItem) }"
  >
    <div class="quick-menu-item" @click="expenseHandler('expense')">
      <div class="quick-menu-item-inner">
        <svg-icon type="maintenance" v-if="showMaintenanceFlag(expenseCreateItem)" class="maintenance-icon" />
        <svg-icon class="quick-menu-icon" type="notes" />
        <div class="quick-menu-text">{{ $t('global-1.key168', { cm: '记一笔' }) }}</div>
      </div>
    </div>
    <div class="quick-menu-item" v-if="ocrEnabled" @click="expenseHandler('ocr-event')">
      <div class="quick-menu-item-inner">
        <svg-icon type="maintenance" v-if="showMaintenanceFlag(expenseCreateItem)" class="maintenance-icon" />
        <svg-icon class="quick-menu-icon" type="camera" />
        <div class="quick-menu-text">{{ $t('global-1.key176', { cm: '拍发票' }) }}</div>
      </div>
    </div>
    <div class="quick-menu-item" v-if="canScan" @click="expenseHandler('invoice-scan')">
      <div class="quick-menu-item-inner">
        <svg-icon type="maintenance" v-if="showMaintenanceFlag(expenseCreateItem)" class="maintenance-icon" />
        <svg-icon class="quick-menu-icon" type="scan" />
        <div class="quick-menu-text">{{ $t('global-1.key177', { cm: '扫发票' }) }}</div>
      </div>
    </div>
  </div>
</template>
<script>
/*
 */
import { getIsWhitelist, isStopService } from 'service/main';
import add from 'assets/images/common/add-btn@3x.png';
import blank from 'assets/images/refactor-main/quick-create/blank.png';
import expenseClaim from 'assets/images/refactor-main/quick-create/expense-claim.png';
import loanBill from 'assets/images/refactor-main/quick-create/loan-bill.png';
import request from 'assets/images/refactor-main/quick-create/request.png';
// import expense from 'assets/images/refactor-main/quick-create/expense.png';
// import ocr from 'assets/images/refactor-main/quick-create/ocr.png';
// import scan from 'assets/images/refactor-main/quick-create/scan.png';
import greyArrow from 'assets/images/application/travel/arrow-right@3x.png';
// import maintenance from 'assets/images/refactor-main/maintenance.png';
import corpPayment from 'assets/images/refactor-main/quick-create/corp-payment@3x.png';
import corpRequest from 'assets/images/refactor-main/quick-create/corp-request@3x.png';
import { checkInvoiceEnable } from 'api/expense';

export default {
  name: 'document-creator-v2',
  mixins: [],
  props: {
    createEnters: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      resource: {
        blank,
        expenseClaim,
        request,
        // expense,
        loanBill,
        // ocr,
        // scan,
        add,
        greyArrow,
        // maintenance,
        corpPayment,
        corpRequest,
      },
      expenseCreateItem: this.createEnters[0],
      ocrEnabled: false,
    };
  },
  computed: {
    canScan() {
      return this.COMMON.getOption('receiptSourceOpt.scanningInvoice');
    },
  },
  watch: {},
  methods: {
    expenseHandler(type) {
      if (this.expenseCreateItem) {
        if (this.showMaintenanceFlag(this.expenseCreateItem)) {
          this.$plugins.maintenance.show();
          return;
        }
        this.expenseCreateItem.target = type;
        this.$emit('selectCreateType', this.expenseCreateItem);
      }
    },
    showMaintenanceFlag(appItem) {
      let isWhitelist = false;
      let stopAnnouncement = this.$store.getters.getStopAnnouncement;
      isWhitelist = getIsWhitelist(appItem.appCode, this.$store.getters.getAllApplicationList);
      return isStopService(stopAnnouncement) && !isWhitelist;
    },
  },
  mounted() {
    let userOID = this.$store.getters.getMyInfo && this.$store.getters.getMyInfo.userOID;
    checkInvoiceEnable(userOID).then((res) => {
      this.ocrEnabled = res.data.showOCRFlag;
    });
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/variable.scss';
.quick-menu-list {
  display: flex;
  align-items: center;
  padding: px(20) 0;

  &.maintenance {
    .maintenance-icon,
    .quick-menu-icon,
    .quick-menu-text {
      opacity: 0.6;
    }
  }

  .quick-menu-item {
    flex: 1;
    display: flex;

    .quick-menu-item-inner {
      display: flex;
      align-items: center;
      margin-left: auto;
      margin-right: auto;
      position: relative;

      .maintenance-icon {
        top: -0.1rem;
        left: 0.1rem;
        position: absolute;
        font-size: 32px;
        color: #505564;
      }

      .quick-menu-icon {
        color: $mainColor;
        font-size: 48px;
      }
      .quick-menu-text {
        padding-left: px(16);
        font-family: PingFangSC-Regular;
        font-size: px(28);
        color: #505564;
        letter-spacing: 0;
        line-height: px(28);
      }
    }
  }
}
</style>
